import { MessageModel } from '@/models/message.model'
import { deleteMessageFromChatAction, setActiveChatMessageAction } from '@/redux/chat/actions'
import { all, put } from 'redux-saga/effects'
import { deleteMessageAction } from '../../handles/deleteMessageAction'
import { deleteMessage } from '../createMessageSaga/http/message'
import { toast } from '@/helpers/toast/toast.helper'
import { t } from 'i18next'
import { deleteMessageOnFirebase } from '../_http/message'

export function* deleteMessageSaga(action: ReturnType<typeof deleteMessageAction.request>) {
  const { message: messageToDelete, campaign } = action.payload
  try {
    yield all([
      deleteMessage({
        campaignId: campaign.id,
        token: campaign.token,
        messageId: messageToDelete.messageId,
        phone: messageToDelete.phone,
        owner: messageToDelete.fromMe
      }),
      deleteMessageOnFirebase(messageToDelete.messageId)
    ])

    yield put(deleteMessageFromChatAction(messageToDelete))
    yield put(deleteMessageAction.success())
  } catch (error) {
    toast({ type: 'error', message: t('translation:deleteMessageError') })
    yield handleDeleteMessageError(messageToDelete, error)
  }
}

export function* handleDeleteMessageError(message: MessageModel, error: Error) {
  yield put(setActiveChatMessageAction(message))
  yield put(deleteMessageAction.failure({ isError: true }))
}
